import React, { isValidElement, useEffect } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Chip from '@material-ui/core/Chip';
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import styles from "assets/jss/material-kit-react/components/profileStyle.js";
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'


const useStyles = makeStyles(styles);

export default function Projects(props) {
  const { user } = props;
  const classes = useStyles();
  const [state, setState] = React.useState({
    projects: user && user.projects,
    projectTitle:"",
    projectLink:"",
  });
  var Call = () => {
    Axios.post(Config.api + "Authentication/CompleteRegistration", {
      projects:state.projects
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }
      }).then((result) => {
        swal("با موفقیت انجام شد.");
      }).catch((err) => {
        if (err&&err.response&&err.response.status&&err.response.status == 422)
          swal("پارامترهای ارسالی نادرست است.");
          else if(err&&err.response&& err.response.data&&err.response.data.fa_message){
          swal(err.response.data.fa_message);
          }
        else if (err&&err.response&&err.response.data&&err.response.data.message&&err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }
  const handleTextBoxChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };
  const handleUrlClick = (url) => {
    window.open(url, "_blank") //to open new page
  };
  const removeFromList = (source, tttt, valueToRemove) => {
    var e = source.filter(item => item !== valueToRemove)
    setState({ ...state, [tttt]: e })
  };

  
  function validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }
  const addToProjectList = () => {
    if (state.projectTitle == "")
      return swal("عنوان پروژه نمیتواند خالی باشد.");
      if(state.projectLink){
        var url="http://"+state.projectLink;
        if(validURL(url)){
          state.projects.push(state.projectTitle+"[&]"+url)
        }else{
             return swal("آدرس اینترنتی نادرست است");
        }
      }else{
        state.projects.push(state.projectTitle)
      }
    setState({ ...state, "projects": state.projects })
    setState({ ...state, "projectTitle": "", "projectLink": "" })
  };
  
  return (
    <form noValidate autoComplete="off">
      <GridContainer className={classes.root} justify="center">
      <GridItem xs={12} sm={12} md={12}>
          <Paper className={classes.paper} variant="outlined" >
            <GridContainer>
              <GridItem xs={12} sm={12} md={5}>
                <div className={classes.div}>
                  <Typography variant="h6" gutterBottom>
                    پروژه‌ها
      </Typography>
                  <div className={classes.formInput}>
                    <TextField  className={classes.limitWidthMedium} id="standard-basic" name="projectTitle" value={state.projectTitle} onChange={handleTextBoxChange} label="عنوان پروژه" helperText="مثال: درگاه دولت" />
                  </div>
                  <div className={classes.formInput+" "+classes.en}>
                    <TextField type='url' InputProps={{
            startAdornment: <InputAdornment position="start">http://</InputAdornment>,
          }} className={classes.limitWidthMedium} id="standard-basic" name="projectLink" value={state.projectLink} onChange={handleTextBoxChange} label="لینک پروژه" helperText="eg: https://example.gov.ir" />
                  </div>
                  <br />
                  <div className={classes.formInput}>
                    <Button variant="outlined" color="secondary" disableElevation onClick={addToProjectList}>
                      افزودن به لیست
</Button>
                  </div>
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={7}>
                <div className={classes.div}>
                {user && state.projects.length > 0 ? (
                  <div className={classes.formInput+" "+classes.chipMargin}>
                        {user && state.projects.map((project) => {
                          var inputProps = {
                          };
                          if(validURL(project.split('[&]')[1])){
                          inputProps.onClick=()=>handleUrlClick(project.split('[&]')[1]);
                          }
                          return (
                            <Chip {...inputProps} variant='outlined' label={project.split('[&]')[0]}  onDelete={() => { removeFromList(state.projects, 'projects', project) }} color="primary"  />
                          );
                        })}
                  </div>
                ) : <p><br/>موردی جهت نمایش وجود ندارد.</p>}
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.en +" " +classes.save}>
                <Button variant="contained" color="primary" disableElevation onClick={Call}>
                     ذخیره سازی
</Button>
                </div>
              </GridItem>
            </GridContainer>
          </Paper>
        </GridItem>

</GridContainer>
    </form>
  );
}